module.exports = __webpack_public_path__ + "static/media/word.dc86248d.png";